<div class="modal fade" :id="modalComponentId" tabindex="-1" role="dialog" :aria-labelledby="modalComponentId + 'Label'" aria-hidden="true" data-backdrop="static" data-keyboard="false">
    <div class="modal-dialog modal-xl" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" :id="modalComponentId + 'Label'">{{modalHeading}}</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="onModalCloseClick">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <div class="alert alert-success alert-dismissible fade show" role="alert" v-if="showSuccessMessage">
                    {{successMessage}}
                    <button type="button" class="close" data-dismiss="alert" aria-label="Close" @click="clearMessageAlerts">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="alert alert-danger alert-dismissible fade show" role="alert" v-if="showErrorMessage">
                    {{errorMessage}}
                    <button type="button" class="close" data-dismiss="alert" aria-label="Close" @click="clearMessageAlerts">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="form-group" v-if="!showSuccessMessage && !showErrorMessage">
                    <label>
                        Effective Date
                    </label>
                    <div class="text-danger">
                        {{effectiveDateErrorMessage}}
                    </div>
                    <date-picker :format="'DD/MM/YYYY'" :elementId="'effectiveDateSelect'" :date="effectiveDate"
                                 :initialiseDate="initialiseDate"
                                 @dateChange="onEffectiveDateSelect"></date-picker>
                </div>
                <div class="form-group" v-if="!showSuccessMessage && !showErrorMessage">
                    <label>
                        Depot
                    </label>
                    <div class="text-danger">
                        {{depotErrorMessage}}
                    </div>
                    <bootstrap-select  :selectOptions="depots" :selectedOption="selectedDepotId" :elementId="'depotSelect'"
                                       :returnSelectedOptionText="true"
                                       @changeSelect="onDepotSelect"></bootstrap-select>
                </div>

                
                <div class="table-responsive pt-4" v-if="!showSuccessMessage && !showErrorMessage">
                    <table class="table table-hover mb-0">
                        <thead>
                            <tr>
                                <th>
                                    Select
                                </th>
                                <th>#</th>
                                <th>Name</th>
                                <th>Price</th>
                                <th v-if="!isAdditionalProducts">Transport Factor</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(depotProduct, index) in products" :key="index">
                               <td>
                                    <input type="checkbox" v-model="depotProduct.isSelected">
                               </td>
                               <td>{{depotProduct.productId}}</td>
                               <td>{{depotProduct.name}}</td>
                               <td>
                                   <div class="text-danger">
                                       {{depotProduct.errorMessagePrice}}
                                   </div>
                                   <currency-input class="form-control" v-model="depotProduct.price"
                                                   :options="{ currency: 'ZAR', currencyDisplay: 'narrowSymbol', autoDecimalDigits: true, hideCurrencySymbolOnFocus: false }"
                                                   :disabled="!depotProduct.isSelected" @blur="onProductSelect"></currency-input>
                               </td>
                               <td v-if="!isAdditionalProducts">
                                   <div class="text-danger">
                                       {{depotProduct.errorMessageTransportFactor}}
                                   </div>
                                   <currency-input class="form-control" v-model="depotProduct.transportFactor"
                                                   :options="{ currency: 'ZAR', currencyDisplay: 'narrowSymbol', autoDecimalDigits: true, hideCurrencySymbolOnFocus: false }"
                                                   :disabled="!depotProduct.isSelected" @blur="onProductSelect"></currency-input>
                               </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-success" @click="validateDepotProductPrices" :disabled="loading" v-if="!showSuccessMessage && !showErrorMessage">SAVE</button>
                <button type="button" class="btn btn-secondary" :disabled="loading" data-dismiss="modal" @click="onModalCloseClick" v-if="!showSuccessMessage && !showErrorMessage">CLOSE</button>
                <button type="button" class="btn btn-primary" :disabled="loading" v-if="showSuccessMessage || showErrorMessage" @click="clearMessageAlerts">OK</button>
            </div>
        </div>
    </div>
</div>